const view = /*html*/`

    <!--begin::Container-->
    <div id="kt_content_container" class="container-xxl">
        <div class="alert-compatible"></div>
        <div class="container-fluid">
            <div class="d-md-flex align-items-center justify-content-center text-center">
                <div class="row align-items-center justify-content-center">
                    <div class="col-sm-12 col-md-12 col-lg-6">
                        <div class="flex-fill w-100 p-2">
                            <h1 class="display-4 teko-header"><span class="" style="color:#ea572b">Akros</span> <span data-i18n="akros.ac">Anti-Cheat</span></h1>                            
                            <p class="lead" data-i18n="akros.dev">Developed and designed by veteran gamers to ensure all competitive games are based on skill, not cheats.</p>
                            <p data-i18n="akros.des">Akros Anti-Cheat is a hybrid anti-cheat using heuristic and signature-based detection schemes to identify known and unknown cheats.</p>
                            <a href="https://pdxplay.net/ac/setup.exe" class="btn btn-lg btn-light-primary btn-active-primary btn-active-color-gray-200 external-handler"><i class="fad fa-cloud-download-alt fs-3 me-1"></i><span data-i18n="example.download">Download</span></a>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                        <div class="flex-fill w-100 p-2">
                            <img class="img-fluid" src="assets/media/logos/header-akros-1.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid">
            <div class="d-md-flex align-items-center justify-content-center text-center">
                <div class="row align-items-center justify-content-center">
                    <div class="col-sm-12 col-md-12 col-lg-6">
                        <div class="flex-fill w-100 p-2">
                            <img class="img-fluid" src="assets/media/logos/akros-download.png" alt="">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                        <h1 class="display-4 teko-header"><span data-i18n="example.download">Download</span> <span class="" style="color:#ea572b">Akros</span></h1>                        
                        <p class="lead" data-i18n="akros.click">Click the link below to directly download Akros</p>
                        <p>
                            <a href="https://pdxplay.net/ac/setup.exe" class="btn btn-lg btn-light-primary btn-active-primary btn-active-color-gray-200 external-handler"><i class="fad fa-cloud-download-alt fs-3 me-1"></i><span data-i18n="example.download">Download</span></a>
                        </p>
                        <p data-i18n="akros.sup">Operating systems supported:</p>
                        <!--<img class="w-75px img-fluid" src="assets/media/logos/w7.png" alt="">
                        <img class="w-125px img-fluid" src="assets/media/logos/w8.png" alt="">-->
                        <img class="w-125px img-fluid" src="assets/media/logos/w10.png" alt="">
                        <img class="w-125px img-fluid" src="assets/media/logos/w11.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>`;
           



const old = `
    <div class="d-flex flex-column flex-center w-100 min-h-350px min-h-lg-500px px-9">
        <!--begin::Heading-->
        <div class="text-center mb-5 mb-lg-10">
            <!--begin::Title-->
            
            <h1 class="text-white lh-base fw-bolder fs-2x fs-lg-3x text-gray-800 mb-15"><span style="color:#ff4800">AKROS</span> ANTICHEAT</h1>
            <!--end::Title-->
            <!--begin::Action-->
            <img class="text-center mb-10" src="assets/media/logos/akros_white.png"><br>
            <div class="fw-bold fs-3 text-gray-700 mb-15" data-i18n="[html]akros.dev">Developed and designed by veteran gamers, <br>to ensure all competitive games <br>are based on skill, not cheats..</div>
            <a href="https://paradoxteam.org/anticheat/setup.exe" class="btn btn-lg btn-outline btn-outline-primary btn-active-light-warning">Download</a>
            <!--end::Action-->


            

        </div>
        <!--end::Heading-->
        


        <div class="card card-flush border-0 h-lg-100 " style="background-color: #7239EA;">
            
            <!--begin::Body-->
            <div class="card-body d-flex justify-content-between flex-column px-0 py-15">
                <!--begin::Wrapper-->
                <div class="d-flex flex-wrap justify-content-around px-9 mb-5">
                    <!--begin::Stat-->
                    <div class="rounded min-w-125px py-7 px-8 my-5" style="border: 1px dashed rgba(255, 255, 255, 0.2)">
                    
                        <div class="text-center">
                            <!--begin::Symbol-->
                            <!--begin::Svg Icon | path: icons/duotune/general/gen025.svg-->
                            <span class="svg-icon svg-icon-4x svg-icon-primary mb-3">
                                <i class="las la-user-alt-slash fs-4x text-success"></i>
                                <!--<i class="las la-user-alt-slash fs-4x text-success"></i>-->
                            </span>
                            <!--end::Svg Icon-->
                            <!--end::Symbol-->                            
                        </div>

                        <!--begin::Number-->
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="text-white fs-lg-2hx fs-2x fw-bolder akros-players-banned" data-kt-countup="true" data-kt-countup-value="" data-kt-countup-suffix="+">0</div>
                        </div>
                        <!--end::Number-->
                        <!--begin::Label-->
                        <div class="fw-bold fs-6 text-white opacity-50" data-i18n="akros.num">Cheaters Banned</div>
                        <!--end::Label-->
                    </div>
                    <!--end::Stat-->
                    <!--begin::Stat-->
                    <div class="rounded min-w-125px py-7 px-8 my-5" style="border: 1px dashed rgba(255, 255, 255, 0.2)">

                        <div class="text-center">
                            <!--begin::Symbol-->
                            <!--begin::Svg Icon | path: icons/duotune/general/gen025.svg-->
                            <span class="svg-icon svg-icon-4x svg-icon-primary mb-3">
                                <i class="las la-user-shield fs-4x text-primary"></i>
                            </span>
                            <!--end::Svg Icon-->
                            <!--end::Symbol-->                            
                        </div>

                        <!--begin::Number-->
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="text-white fs-lg-2hx fs-2x fw-bolder akros-players-using" data-kt-countup="true" data-kt-countup-value="" data-kt-countup-suffix="+">0</div>
                        </div>
                        <!--end::Number-->
                        <!--begin::Label-->
                        <div class="fw-bold fs-6 text-white opacity-50" data-i18n="akros.using">Players Using</div>
                        <!--end::Label-->
                    </div>
                    <!--end::Stat-->
                </div>
                <!--end::Wrapper-->
                
                <!--begin::Testimonial-->
                <div class="fs-3 fw-bold text-white text-center mb-3 px-9" data-i18n="[html]akros.des">
                    Akros Anticheat is a hybrid anti-cheat that uses heuristic <br>and signature based detection schemes to identify both known and unknown cheats <br>by scanning for anomalous objects in memory and on the file system.
                </div>
                <!--end::Testimonial-->
                
            </div>
            <!--end::Body-->
        </div>

        
    </div>					
					

    </div>


`;


export default view;